export const splitMessage = message => message.match(/(.*)\*(.+)\*(.*)/);